import { render } from "./Regions.vue?vue&type=template&id=64ad838a&ts=true"
import script from "./Regions.vue?vue&type=script&lang=ts"
export * from "./Regions.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__